export default __webpack_public_path__ + "static/media/unduh_white.01068713.png";